<template>
  <div class="OverseasTrainPage" v-if="!this.showLoad">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.applicantName"
          v-if="mode != 'add'"
          readonly
          input-align="right"
          label="申请人："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.realName"
          class="ggInput"
          v-else
          input-align="right"
          readonly
          label="申请人："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.trainingAgency"
          :required="editType"
          :readonly="!editType"
          input-align="right"
          label="培训机构："
          class="ggInput"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.courseName"
          class="ggInput"
          :required="editType"
          :readonly="!editType"
          input-align="right"
          label="课程名称："
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseData.cost"
          class="ggInput"
          type="number"
          :required="editType"
          :readonly="!editType"
          input-align="right"
          label="培训费用(元)："
          :placeholder="editType ? '请输入...  ' : ''"
          @blur="checkMoney(baseData.cost)"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.phone"
          class="ggInput"
          :required="editType"
          :readonly="!editType"
          input-align="right"
          label="联系电话："
          maxlength="11"
          type="tel"
          :placeholder="editType ? '请输入...  ' : ''"
          @blur="checkTel(baseData.phone)"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.address"
          class="ggInput"
          :required="editType"
          :readonly="!editType"
          input-align="right"
          label="培训地点："
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.startTime"
          :required="editType"
          class="ggInput"
          input-align="right"
          label="开始时间："
          readonly
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
          @click="getTimes('start')"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.endTime"
          :required="editType"
          class="ggInput"
          input-align="right"
          label="结束时间："
          readonly
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
          @click="getTimes('end')"
        />
      </van-cell-group>

      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="baseData.projectName"
          :required="editType"
          type="textarea"
          label="所属项目："
          placeholder="请选择"
          @click="checkItemPicker"
          :is-link="editType"
          readonly
          class="ggInput"
          input-align="right"
          rows="1"
          autosize
        />
      </van-cell-group>

      <div class="claimDetailMain">
        <!-- <p class="fgx"></p> -->
        <p class="tit">培训人员</p>
        <van-cell-group class="claimDetailBox">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in personList"
              :key="item.typeCode"
            >
              <van-cell-group class="baseNone baseSalary" v-if="item.name">
                <van-field
                  v-model="item.deptName"
                  label="部门："
                  :required="editType"
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary" v-if="item.name">
                <van-field
                  v-model="item.position"
                  :required="editType"
                  label="岗位："
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.name"
                  label="姓名："
                  :required="editType"
                  readonly
                  class="ggInput"
                  input-align="right"
                  @click="showPickerFun(index)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>

              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.remarks"
                  clearable
                  :readonly="!editType"
                  class="ggInput"
                  input-align="right"
                  label="备注："
                  :placeholder="editType ? '请输入...  ' : ''"
                />
              </van-cell-group>

              <div class="delect" v-if="personList.length > 1 && editType">
                <van-icon name="cross" @click="delect(index)" />
              </div>
            </div>
          </div>
          <div class="addBtn" v-if="editType">
            <van-button
              icon="plus"
              type="primary"
              class="addClaim"
              size="small"
              @click="addClaim"
              >添加培训人员</van-button
            >
          </div>
        </van-cell-group>
      </div>

      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="baseData.content"
          rows="1"
          autosize
          label="培训内容："
          type="textarea"
          :required="editType"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="baseData.purpose"
          rows="1"
          autosize
          label="培训目的："
          type="textarea"
          :required="editType"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary textLeft beizhu">
        <p class="moreTit">
          针对申请的培训课程,请列出目前岗位工作需要提升/不足的项目:
        </p>
        <van-field
          v-model="baseData.shortage"
          :required="editType"
          rows="1"
          autosize
          type="textarea"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="baseData.remarks"
          rows="1"
          autosize
          label="备注："
          type="textarea"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>

      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && baseData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="baseData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && baseData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="baseData"></flow-staff>
        <flow-list :workflowCode="baseData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="baseData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        baseData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          baseData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          baseData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出框 -->

    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 选择人员 -->
    <van-popup v-model="showPersonnelPicker" position="bottom" class="roleBox">
      <redio-retinue-view @setReview="setPersonnelMsg"></redio-retinue-view>
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const projectView = () => import("@/components/businessTripMould/projectView");
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView"); //附件
const wxFileView = () => import("@/components/common/wxFileView"); //微信附件
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const flowStaff = () => import("@/components/common/flowStaff");
const verifyMain = () => import("@/components/common/verifyMain");
const redioRetinueView = () =>
  import("@/components/businessTripMould/redioRetinueView");
import { dateFormat, dateTimeFormat } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "OverseasTrain",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      mode: "add",
      editType: false, //能否编辑
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      showItemPicker: false, //所属项目弹框
      timeType: "", //判断开始时间-结束时间
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      baseData: {
        id: "",
        trainingAgency: "", //培训机构
        courseName: "", //课程名称
        cost: "", //培训费用
        phone: "", //联系电话
        address: "", //培训地点
        startTime: "", //培训开始时间
        endTime: "", //培训结束时间
        createTime: "", //申请时间
        projectName: "", //所属项目名称
        projectCode: "", //所属项目code
        content: "", //培训内容
        purpose: "", //培训目的
        shortage: "", //工作需要提升项目
        remarks: "", //备注
        personList: [],
        baseAnnexes: [], //附件
        verifyStatus: "hold",
      },
      personList: [
        //添加人员数组
        {
          deptId: "",
          deptName: "", //部门名称

          position: "", //岗位名称
          name: "", //姓名
          remarks: "",
          uid: "",
        },
      ],
      personIndex: "",
      showPersonnelPicker: false,
      clientType: getDeviceType(),
      sendType: "",
      refreshing: false, //无数据显示
      is_weixn: is_wei(), //是否为微信
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "外派培训申请";
    }
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面

    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify" || this.mode == "view") {
        this.initPage();
      } else {
        this.setShowLoad(false);
      }
    });
  },
  components: {
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    projectView,
    verifyMain,
    flowStaff,
    redioRetinueView,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    addClaim() {
      //添加人员选择明细
      this.personList.push({
        deptId: "",
        deptName: "", //部门名称

        position: "",
        name: "", //姓名
        remarks: "",
        uid: "",
      });
    },

    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.baseData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.userCenter.user.overseasTrain
            .delApply(this.baseData.verifyStatus, _this.baseData.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "操作成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    delect(index) {
      this.personList.splice(index, 1);
    },

    initPage() {
      let _this = this;
      _this.setShowLoad(false);
      _this.$api.userCenter.user.overseasTrain
        .trainDetail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = newApi.assign({}, _this.baseData, res.data);
            _this.personList = res.data.personList
              ? res.data.personList
              : [
                  {
                    deptId: "",
                    deptName: "", //部门名称
                    positionName: "", //岗位名称
                    position: "",
                    name: "", //姓名
                    remarks: "",
                    uid: "",
                  },
                ];
            if (_this.baseData.remarks == null) {
              _this.$set(_this.baseData, "remarks", "");
            }
            _this.$set(_this.baseData, "projectCode", res.data.projectId);

            if (
              (_this.baseData.verifyStatus == "hold" ||
                _this.baseData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //时间选择
    getTimes(type) {
      if (this.editType) {
        this.timeType = type;
        this.showTimePicker = true;
      }
    },
    onTimeConfirm(data) {
      let time = dateTimeFormat(data);
      if (this.timeType == "start") {
        this.$set(this.baseData, "startTime", time);
      } else {
        this.$set(this.baseData, "endTime", time);
      }
      this.showTimePicker = false;
    },

    //项目信息
    checkItemPicker() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    setProject(data) {
      //获取所属项目
      let _this = this;
      if (data != "") {
        console.log(data, "data");
        _this.baseData.projectCode = data.id;
        _this.baseData.projectName = data.name;
      }
      this.showItemPicker = false;
    },

    //人员选择
    showPickerFun(index) {
      if (this.editType) {
        this.personIndex = index;
        this.showPersonnelPicker = true;
      }
    },
    setPersonnelMsg(data) {
      //人员选择回调

      this.$set(this.personList[this.personIndex], "name", data.realName);
      this.$set(this.personList[this.personIndex], "uid", data.id);
      this.$set(this.personList[this.personIndex], "deptId", data.depId);
      this.$set(
        this.personList[this.personIndex],
        "deptName",
        data.departmentName
      );
      this.$set(
        this.personList[this.personIndex],
        "position",
        data.positionName
      );

      this.showPersonnelPicker = false;
    },
    //金额校验
    checkMoney(item) {
      let _this = this;
      if (item < 0) {
        _this.$toast("培训金额必须大于0");
        this.baseData.cost = "";
      }
    },
    //电话校验
    checkTel(item) {
      let phone = item;
      if (!/^1[23456789]\d{9}$/.test(phone)) {
        this.$toast("请填写正确的手机号码");
        this.baseData.phone = "";
      }
    },
    //保存
    checkInput() {
      let _this = this;
      if (_this.validate()) {
        _this.btnLoading = true;
        let params = _this.baseData;
        params.projectId = params.projectCode;
        params.personList = _this.personList;
        _this.$api.userCenter.user.overseasTrain
          .addApply(_this.mode, params)
          .then((res) => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },

    validate() {
      let _this = this;
      if (
        _this.baseData.address == "" ||
        _this.baseData.content == "" ||
        _this.baseData.cost == "" ||
        _this.baseData.courseName == "" ||
        _this.baseData.phone == "" ||
        _this.baseData.purpose == "" ||
        _this.baseData.startTime == "" ||
        _this.baseData.endTime == "" ||
        _this.baseData.trainingAgency == "" ||
        _this.baseData.shortage == ""
      ) {
        _this.$toast("请完善表单信息");
        return false;
      }
      if (_this.personList.length > 0) {
        for (var i = 0; i < this.personList.length; i++)
          if (
            _this.personList[i].deptName == "" ||
            _this.personList[i].name == "" ||
            _this.personList[i].position == ""
          ) {
            _this.$toast("请完善表单信息");
            return false;
          }
      }
      return true;
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.OverseasTrainPage {
  width: 100%;
  background-color: #f6f6f6;
  padding-bottom: 60px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  .moneyPicker {
    width: 100%;
    height: 90%;

    background-color: #f6f6f6;
    .van-popup__close-icon--top-right {
      top: 5px;
      right: 5px;
      color: red;
    }
    ul {
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding: 16px 16px 20px 16px;

      li {
        width: 100%;
        padding: 8px 8px;
        margin: 10px 0;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        .incomeInfo {
          p {
            width: 100%;
            overflow: hidden;
            font-size: 15px;
            line-height: 20px;
            margin: 5px 0;
            color: #333;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 135px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -67px;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  .delectBtn {
    width: 50%;
  }
  #searchHeight {
    text-align: left;
  }

  //添加明细样式
  .claimDetailMain {
    background-color: #fff;
    .fgx {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6;
    }
    p.tit {
      width: 100%;
      padding: 0 16px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      color: #2581d6;
      border-bottom: 1px solid #f6f6f6;
    }
    // p.tit:before {
    //   content: "";
    //   position: absolute;
    //   width: 5px;
    //   height: 20px;
    //   background: #2581d6;
    //   top: 13px;
    //   left: 16px;
    // }
    .baseNone::after {
      content: none;
    }
    .claimDetailBox.van-cell-group.van-hairline--top-bottom::after {
      content: none;
    }
  }
  .claimDetailBox {
    width: 100%;
    padding-bottom: 10px;
    .claimDetailLists {
      width: 95%;
      margin: 0 auto;
      min-height: 140px;
    }
    .addBtn {
      margin-top: 10px;
      width: 100%;
      .addClaim {
        display: block;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
      }
    }
  }
  .projectIncome {
    position: relative;
    .xmsrStyle {
      .van-cell__value {
        width: 50%;
      }
    }
    .ggInput.xmsrStyle.van-cell::after {
      content: none;
    }
  }
  .changeW.projectIncome {
    span.percent {
      position: absolute;
      width: 35px;
      top: 13px;
      right: 45px;
      color: #969799;
      font-size: 15px;
      text-align: right;
    }
  }
  .claimItem {
    margin-top: 10px;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    position: relative;
    .delect {
      text-align: center;
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      background: #fff;
      border: 1px solid red;
      color: red;
      cursor: pointer;
      padding-top: 1px;
    }
  }
  .baseNone {
    .van-cell__title {
      span {
        color: #323233;
      }
    }
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.textLeft {
    .van-cell--required::before {
      top: -43px;
    }
    .van-field__body {
      .van-field__control {
        text-align: left;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
    .moreTit {
      width: 100%;
      padding: 10px 16px 0;
      font-size: 15px;
      color: #323233;
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>